module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-mindfulness-skills-large@2x.999a8092.png";